import { CURRENCY } from '@shared/constants';

/**
 * Convert cents to currency units
 */
export function centsToUnits(cents: number): number {
  return cents / CURRENCY.CENTS_PER_UNIT;
}

/**
 * Convert currency units to cents
 */
export function unitsToCents(units: number): number {
  return Math.round(units * CURRENCY.CENTS_PER_UNIT);
}

/**
 * Format amount in cents to currency string
 */
export function formatCurrency(cents: number, showSymbol = true): string {
  const units = centsToUnits(cents);
  const formatted = units.toFixed(2);
  
  return showSymbol ? `${CURRENCY.SYMBOL}${formatted}` : formatted;
}

/**
 * Parse currency string to cents
 */
export function parseCurrency(value: string): number {
  const cleanValue = value.replace(/[^0-9.,]/g, '').replace(',', '.');
  const units = parseFloat(cleanValue);

  if (isNaN(units)) {
    return 0;
  }

  return unitsToCents(units);
}

/**
 * Format price according to Estonian conventions
 * Formats as: XX,XX € (comma decimal separator, euro sign after with space)
 *
 * @param price - Price in euros (number)
 * @returns Formatted price string (e.g., "39,50 €")
 */
export function formatPrice(price: number | null | undefined): string {
  // Handle edge cases: null, undefined, NaN
  if (price === null || price === undefined || isNaN(price)) {
    return `0,00 ${CURRENCY.SYMBOL}`;
  }

  // Format to 2 decimal places and replace dot with comma
  const formatted = price.toFixed(2).replace('.', ',');

  return `${formatted} ${CURRENCY.SYMBOL}`;
}